exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SingleValueDisplayReport .displayValue {\n  font-size: 80px;\n  font-weight: normal;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.page .nodata .helperMsg {\n  padding-top: 15px;\n}", ""]);

// exports
